import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showToast = (message, type = 'info') => {
  switch (type) {
    case 'success':
      toast.success(message);
      break;
    case 'error':
      toast.error(message);
      break;
    case 'warn':
      toast.warn(message);
      break;
    default:
      toast.info(message);
  }
};

const Toast = () => {
  return <ToastContainer position="bottom-center" autoClose={5000} hideProgressBar={false} closeOnClick pauseOnHover />;
};

export default Toast;
